import React from "react";
import NO_AVA from "styles/img/regular-logo.png";
import moment from "moment";
import { inject } from "mobx-react";
import WorkshopButtons from "blocks/WorkshopButtons";
import AssignButton from "blocks/AssignButton";
import { withRouter } from "react-router-dom";
import EyeViewComponent from "blocks/EyeViewsComponent";
import HttpClient from "services/HttpClient";
import classnames from 'classnames';

const COLOR = "#00c0c3";
const CPD_FALSE = (
  <svg width="10" height="9">
    <path
      fill="#FF524F"
      fillRule="evenodd"
      d="M2.292.758L.947 2.104l2.7 2.7-2.7 2.7L2.292 8.85l2.701-2.7 2.7 2.7 1.346-1.346-2.701-2.7 2.701-2.7L7.693.758l-2.7 2.701L2.292.758"
    />
  </svg>
);
const CPD_TRUE = (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="10">
    <path
      fill={COLOR}
      fillRule="evenodd"
      d="M10.753.82l1.556 1.571-7.26 7.333L.383 5.01l1.555-1.571 3.111 3.143L10.753.82z"
    />
  </svg>
);
const USERS_FOR_ASSIGN_CHANGE_URL = "/api/v1/workshops/assign_provider/";

@withRouter
@inject("user", 'modal', 'alert')
export default class RegularWorkshop extends React.Component {
  handleDelete = () => {
    this.props.handleDelete(this.props.workshop.id);
  };

  redirect = () => {
    // if(!this.props.user.getUser()){
    //   this.props.history.push('/newuser/signin/');
    //   return;
    // }
    let user = this.props.user.getUser();
    if (user && this.props.workshop.created_by === user.id)
      this.props.history.push("/provider/regular/" + this.props.workshop.id);
    if (user && user.role === "admin")
      this.props.history.push("/admin/regular/" + this.props.workshop.id);
    else this.props.history.push("/details/regular/" + this.props.workshop.id);
  };

  assignedUser = (user_id) => {
    const workshopId = this.props.workshop.id;
    const userIdData = { provider_id: user_id };

    new HttpClient()
      .put(USERS_FOR_ASSIGN_CHANGE_URL + workshopId, userIdData)
      .then(response => {
          this.props.modal.toggleModal();
          this.props.updateWorkshopFromList(response.body.workshop)
          this.props.alert.success('User Selected!')
      });
  };

  getStatus = status => {
    switch(status) {
      case 'workshop_completed':
        return 'Completed';
      case 'workshop_not_started':
        return 'Incomplete';
      case 'workshop_trainee_progress':
        return 'In Progress';
      case 'workshop_check_response':
        return 'Incomplete';
      default:
        return '';
    }
  }

  render() {
    let user_id;
    const user = this.props.user.getUser();
    if (user) user_id = user.id;
    let workshop = this.props.workshop;
    const showStatus = user && workshop.created_by !== user.id && user.role !== 'admin' && workshop.status;
    return (
      <section
        className="card regular workshop-card regular-list"
        onClick={this.redirect}
      >
        <div className="card-avatar-wrap">
          <div className="will-hide">
            <div className="card-avatar-wrap-inner">
              {workshop.provider_logo_url ? (
                <img
                  src={workshop.provider_logo_url}
                  alt="ava"
                  className="has-ava"
                />
              ) : (
                <img
                  src={NO_AVA}
                  alt="avatar"
                  className="no-ava full-ava-preview "
                />
              )}
            </div>
            <p className="provide">PROVIDED BY</p>
            <p className="name">{workshop.provided_by}</p>
          </div>

          <AssignButton
            admin={
              this.props.user.getUser() &&
              this.props.user.getUser().role === "admin"
            }
            id={this.props.workshop.id}
            assigned={this.props.workshop.assigned_to_provider}
            provider={this.props.workshop.provider}
            assignedUser={this.assignedUser}
          />
        </div>
        <div className="card-content-wrap">
          <div>
            <div className="card-head">
              <div className="card-head-top">
                <span className="card-head-date">
                  {moment(workshop.start_date).format("D MMM`YY")}
                </span>
                <span className="card-head-place">
                  <i className="ic-map-ico" />
                  {workshop.venue_county}
                </span>
                <EyeViewComponent count={workshop.views_count} online={false} />
              </div>
              <p className="card-title" style={{ color: "#00c0c3", width: '65%' }}>
                {workshop.title}
              </p>
              {showStatus && (
                <span
                  className={classnames('list-workshops-status', {
                    completed: workshop.status === 'workshop_completed' || workshop.status === 'workshop_check_response'
                  })}
                >
                  {this.getStatus(workshop.status)}
                </span>
              )}
            </div>
            <div className="card-content">
              <p
                className="card-desc"
                dangerouslySetInnerHTML={{ __html: workshop.short_description }}
              />
            </div>
          </div>

          <div className="card-footer-bottom">
            <ul className="card-info ">
              <li>
                <ul className="suitableFor">
                  <li key="wdw">
                    {" "}
                    <p className="card-info-title">Suitable for: </p>
                  </li>
                  {this.props.workshop.target_audience.map((el, i) => (
                    <li key={i}>
                      <span style={{ color: COLOR }}>{el}</span>
                    </li>
                  ))}
                </ul>
              </li>
              <li>
                <p className="card-info-title" key="info">
                  CPD Hours:
                  {/* <span className="card-info-sub">
                    {this.props.workshop.cpd_hours
                      ? this.props.workshop.how_many_hours
                      : "Check with provider"}
                  </span> */}
                  <span className="card-info-sub">
                    {this.props.workshop.cpd_hours
                      ? this.props.workshop.how_many_hours
                      : "No"}
                  </span>
                </p>
              </li>
              <li>
                <p className="card-info-title" key="modules">
                  Modules:
                  <span className="card-info-sub" style={{color: COLOR}}>
                    {workshop.modules_count || 0}
                  </span>
                </p>
              </li>
              <li>
                <p className="card-info-title" key="cost">
                  PRICE:
                  <span className="card-info-sub" style={{ color: COLOR }}>
                    {parseFloat(this.props.workshop.cost)
                      ? [
                          <span className="currency euro" key="pound" />,
                          this.props.workshop.cost
                        ]
                      : "FREE"}
                  </span>
                </p>
              </li>
            </ul>
            <WorkshopButtons
              owner={this.props.workshop.created_by === user_id}
              type="regular"
              emptyUser={!this.props.user.getUser()}
              admin={
                this.props.user.getUser() &&
                this.props.user.getUser().role === "admin"
              }
              id={this.props.workshop.id}
              handleDelete={this.handleDelete}
            />
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/RegularWorkshop.jsx